import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeRoof: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHomeRoof"><Path d="M4.5 8.5L4.50001 20.5H19.5L19.5 8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2 9.75L12 2.44879L22 9.75" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHomeRoof;
